import { Component, Input } from "@angular/core";

@Component({
    selector: 'custom-card',
    templateUrl: './custom-card.component.html',
    styleUrls: ['./custom-card.component.scss'],
})
export class CustomCardComponent {
    @Input() icone: string;
    @Input() titulo: string;
    @Input() link: string;
    @Input() rota: string = null;
}
